import { useModal } from "hooks/useModal"
import { useAppDispatch } from "reducers/store"

import styled from "styled-components"
import { useCallback, memo } from "react"
import IconPlusTime from "components/EvtKit/icons/IconPlusTime"
import { setAccount } from "reducers/accounts/accounts-actions"
import clsx from "clsx"
import { Colors } from "themes/palette"
import Tooltip from "components/Tooltip"

const InlineButton = styled.div`
  width: 25px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 16px;

  svg {
    width: 25px;
    height: 24px;
  }

  &.disabled {
    cursor: not-allowed;
  }
`

interface AddFreeTrialButtonProps {
  account: App.Account
}

const AddFreeTrialButton = (props: AddFreeTrialButtonProps) => {
  const { account } = props

  const appDispatch = useAppDispatch()

  const { openModal } = useModal()

  const disabledButton = account.purchasePlan.planKey != ""

  const handleOnClick = useCallback(async () => {
    if (disabledButton) return

    openModal("addFreeTrial")
    appDispatch(setAccount(account))
  }, [account, disabledButton])

  const tooltipText = disabledButton
    ? "Não é possivel adicionar mais tempo de free trial para contas com plano pago ativo."
    : "Adicionar mais tempo de free trial"

  return (
    <Tooltip text={tooltipText} toolTipClassName="align-right position-absolute">
      <InlineButton onClick={handleOnClick} className={clsx({ disabled: disabledButton })}>
        <IconPlusTime color={disabledButton ? Colors.disabled : Colors.primary_one} />
      </InlineButton>
    </Tooltip>
  )
}

export default memo(AddFreeTrialButton)
